import { Page } from "@/models/page-models/Page";

export const QuotationView: Page = {
  "path": "quotation/:quotationId",
  "name": "Quotation(old)",
  "props": {
    "data": {
      "title": "Quotation(old)",
      "arabicTitle": "اقتباس",
      "printable": "FALSE",
      "url": "quotation/:quotationId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "custom_QuotationDetails",
                  "variable": "fetchedData.quotation.data",
                  "label": "Quotation Details",
                  "config": {
                    "customerDetailsVariable": "fetchedData.selectedCustomer"
                  }
                }
              ]
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.quotation.data.orders",
                  "label": "Products Table",
                  "disabled": "TRUE",
                  "items": "fetchedData.products.data.docs",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "Sl. No",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{formData.orders}}))"
                    },
                    {
                      "value": "order",
                      "text": "Order #",
                      "type": "url",
                      "formula": "{{__variable.order._id}}",
                      "url": "/order/{{__variable.order._id}}"
                    },
                    {
                      "value": "customerPo",
                      "text": "Cust. PO#",
                      "type": "formula",
                      "formula": "{{__variable.order.customerPO}}"
                    },
                    {
                      "value": "__item._id",
                      "text": "Item ID",
                      "type": "url",
                      "formula": "{{__item._id}}",
                      "url": "/products/{{__item._id}}"
                    },
                    {
                      "value": "__item.productLine",
                      "text": "Description",
                      "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                    },
                    {
                      "value": "customerItemId",
                      "text": "Cust. Item ID"
                    },
                    {
                      "value": "__item.repeatType",
                      "text": "Type",
                      "type": "productRepeatType"
                    },
                    {
                      "value": "__item.unit.unit2",
                      "text": "Selling Unit"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__variable.productPrice.price}})"
                    },
                    {
                      "value": "__item.minimumQuantity",
                      "text": "MOQ",
                      "formula": "fn(HELPER_FN,numFormat,{[__item.minimumQuantity}},true)"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{__variable.quantity}},true)"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{__variable.FOC}},true)"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__variable.productPrice.price}},{{__variable.quantity}}))"
                    },
                    {
                      "value": "deliveryDate",
                      "text": "Delivery Date",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,dateFormat,{{__variable.order.deliveryDate}})"
                    },
                    {
                      "value": "status",
                      "text": "Status",
                      "type": "formula",
                      "formula": "{{__variable.order.status}}"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "product._id",
                  "itemKey": "_id",
                  "showActions": false,
                  "footer": {
                    "value": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{formData.orders}},product))",
                    "quantity": "Total Value"
                  },
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Terms & Conditions",
                  "class": "text-subtitle-2"
                }
              ]
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Payment Terms",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,fn(LOGICAL,{{formData.termsAndConditions.paymentTerms.advancePercent}},>,0),fn(CONCAT,{{formData.termsAndConditions.paymentTerms.advancePercent}},\"% cash in advance, balance \",{{formData.termsAndConditions.paymentTerms.daysAfterInvoice}}, days from invoice date (prices exclude VAT tax)),fn(CONCAT,{{formData.termsAndConditions.paymentTerms.daysAfterInvoice}}, days from invoice date (prices exclude VAT tax)))",
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "5b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Quantity Tolerance",
                  "showIf": "fn(LOGICAL,{{formData.termsAndConditions.tolerance}},>,-1)",
                  "labelType": "formula",
                  "formula": "+/- {{formData.termsAndConditions.tolerance}}% from ordered quantity",
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "6b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Call Off Lead Time",
                  "showIf": "{{formData.termsAndConditions.deliveryLeadTime}}",
                  "labelType": "formula",
                  "formula": "{{formData.termsAndConditions.deliveryLeadTime}} days",
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "7b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Trade Terms",
                  "labelType": "formula",
                  "formula": "{{formData.termsAndConditions.tradeTerms.type}} {{formData.termsAndConditions.tradeTerms.place}}",
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "8b",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.termsAndConditions.shippingMode",
                  "label": "Shipping Mode",
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "9b",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "formData.uploadedProof",
                  "label": "PO",
                  "disabled": "TRUE",
                  "showIf": "{{formData.uploadedProof}}",
                  "color": "primary",
                  "class": "text-caption",
                  "previewType": "standard"
                }
              ]
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.info",
                  "label": "Additional Notes(Comments)",
                  "disabled": "FALSE",
                  "inputType": "longText",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Approved'),&&,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending Approval'))"
            },
            {
              "name": "11b",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.status",
                  "label": "Status",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,qtStatus,{{fetchedData.quotation.data}})",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.updatedAt}},show-time)",
                  "printable": false
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Approved'),&&,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending Approval'))"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getQuotationDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/get?id={{__params.quotationId}}&getLatest=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.quotation",
          "arg3Key": "fnsAfterSubmit",
          "arg3Value": "[{\"name\":\"copyCustomerDetails\",\"executionOrder\":1},{\"name\":\"copyQuotationData\",\"executionOrder\":1}]"
        },
        "name": "getQuotationDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToScView",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/view-sales-contract/{{__params.quotationId}}"
        },
        "name": "redirectToScView",
        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.type}},'),==,'Sales Contract')"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductsForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToProductForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "formData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.productForm.q.customer"
        },
        "name": "pushCustomerIdToProductForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProducts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/search",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.productForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.products",
          "arg4Key": "fnsAfterSubmit",
          "arg4Value": "[{\"name\":\"createCurrentProductsArray\",\"executionOrder\":1}]"
        },
        "name": "getProducts"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyOldPoProof",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "formData.uploadedProof.0",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.uploadedProof"
        },
        "name": "copyOldPoProof",
        "executeIf": "{{formData.uploadedProof.0}}"
      }
    ],
    "functions": [
      {
        "name": "copyCustomerDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.quotation.data.customer",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedCustomer"
      },
      {
        "name": "getQuotationData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "updatedAt": "fetchedData.quotation.data.updatedAt",
          "customer": "fetchedData.quotation.data.customer._id",
          "status": "fetchedData.quotation.data.status",
          "orders": "fetchedData.quotation.data.orders",
          "uploadedProof": "fetchedData.quotation.data.uploadedProof",
          "customerPO": "fetchedData.quotation.data.customerPO",
          "termsAndConditions": "fetchedData.quotation.data.termsAndConditions",
          "info": "fetchedData.quotation.data.info"
        }
      },
      {
        "name": "copyQuotationData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getQuotationData",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "createCurrentProductsArray",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "formData.orders",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.orders",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "convertCurrentOrders"
      },
      {
        "name": "convertCurrentOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "__selectedObject.product._id",
          "quantity": "__selectedObject.quantity",
          "FOC": "__selectedObject.FOC",
          "productPrice": "__selectedObject.productPrice"
        }
      },
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": ["Draft", "Pending", "Open" ]
          },
          "page": 1
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": false
}